export default __webpack_public_path__ + "static/media/blockimg-livro.f074340d.png";